import React from 'react';
import { isEmpty } from 'lodash';
import { Select, message } from 'antd';
import {
  SourceSelect, Option, RangePicker, Picker, DaySelect,
} from './styles';
import { DATE_FORMAT } from '../../constants/grid.constants';
import { WEEK_DAYS } from '../../constants/dataPages.constants';
import { DATES_OVERLAP, DAY_MINIMUM } from '../../constants/text.constants';

const hasDate = source => source === 'historical';


const VolumePicker = ({
  state: { source, weeks, days }, sources = [], onChange, datesOverlap,
}) => (
  <Picker compact>
    <SourceSelect
      value={source}
      placeholder="Source"
      onChange={s => onChange({ source: s, days })}
    >
      {sources
        .map(s => (
          <Option key={s} value={s}>
            {s}
          </Option>
        ))
      }
    </SourceSelect>

    <DaySelect
      value={days.sort((a, b) => WEEK_DAYS[a] - WEEK_DAYS[b])}
      placeholder="Select Days"
      mode="multiple"
      onChange={
        d => d.length < 1
          ? message.error(DAY_MINIMUM)
          : onChange({ source, weeks, days: d })
      }
    >
      {
        Object.keys(WEEK_DAYS).map(
          day => <Select.Option key={day} title={day}>{day}</Select.Option>,
        )
      }
    </DaySelect>

    {hasDate(source)
      && (
        <RangePicker
          placeholder={['From', 'To']}
          format={DATE_FORMAT}
          value={weeks}
          onChange={w => datesOverlap(w)
            ? message.error(DATES_OVERLAP)
            : onChange({
              source,
              days,
              weeks: !isEmpty(w) ? [w[0].startOf('week'), w[1].endOf('week')] : [],
            })
          }
        />
      )
    }
  </Picker>
);

export default VolumePicker;
